import { useContext } from 'react';
import { ProfessionalsChartsDataContext } from '../contexts/ProfessionalsChartsDataContext';

export const useProfessionalsChartsDataContext = () => {
    return useContext(ProfessionalsChartsDataContext);
};
